export default __webpack_public_path__ + "static/media/project-status-arrears.8bc16929.svg";